import Enum from '@/shared/models/enums/enum';

/**
 * 質問文タイプ
 */
class QuestionType extends Enum {
    static TEMPLATE = 1; // テンプレート文
    static FREE = 2; // 規定文（「先生の指示を聞いて自分の考えを入力しよう」/vue/src/shared/config/mirukiku_product.js）

    static values() {
        return {
            [this.TEMPLATE]: 'テンプレート文',
            [this.FREE]: '規定文',
        }
    }
}

export default QuestionType;
